import {MatchEventsModuleFetchHandler} from "./match-events-module.fetch-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {MatchEventsModuleChangeTabHandler} from "./match-events-module.change-tab-handler";
import {MatchEventModulePlayerClickHandler} from "./match-event.module.player-click.handler";
import {EntityClickEventHandler} from "../../../../../core/handlers/entity-click-event.handler";
import {FullGamePopulateDataHandler} from "../../../../../core/handlers/full-game.populate-data.handler";

export class MatchEventsModuleHandlers extends HandlerList {
  static injectables = [
    MatchEventsModuleFetchHandler,
    MatchEventModulePlayerClickHandler,
    MatchEventsModuleChangeTabHandler,
    EntityClickEventHandler,
    TimingHandler,
    FullGamePopulateDataHandler
  ];

  constructor(
    matchEventsModuleFetchHandler: MatchEventsModuleFetchHandler,
    matchEventModulePlayerClickHandler: MatchEventModulePlayerClickHandler,
    matchEventsModuleChangeTabHandler: MatchEventsModuleChangeTabHandler,
    entityClickEventHandler: EntityClickEventHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler
  ) {
    super();

    [
      matchEventsModuleFetchHandler,
      matchEventModulePlayerClickHandler,
      matchEventsModuleChangeTabHandler,
      entityClickEventHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler))
  }
}
